/**
 * New Feature Request Route Definition (Non-Lazy)
 *
 * validateSearch + template-first pending only — the form (and its
 * @tanstack/react-form + sonner imports) lives in index.lazy.tsx. As a
 * non-lazy component here, the form stack was hoisted into the entry chunk
 * for every user.
 */
import { createFileRoute } from '@tanstack/react-router';
import { FormPageTemplatePending } from '@/components/v2/page-template-pending';
import { v2 } from '@/lib/i18n/v2';

export const Route = createFileRoute('/_authenticated/feature-requests/new/')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      returnUrl: (search.returnUrl as string) || undefined,
    };
  },
  // Template-first pending while the form chunk downloads (first visit), with
  // the loaded page's real title strings so nothing swaps text on arrival.
  // The form submits from the sticky BottomAction bar.
  pendingComponent: () => (
    <FormPageTemplatePending
      title={`${v2.featureRequestNew.title} ${v2.featureRequestNew.titleAccent}`}
      subtitle={v2.featureRequestNew.subtitle}
      cta
    />
  ),
});
